import * as React from 'react';
import { translate } from 'react-i18next';
import * as i18n from 'i18next';
import { IStore } from 'redux/IStore';
const { connect } = require('react-redux');
import * as c from 'models/constants';
import { Dispatch } from 'react-redux';
import { browserHistory, Link, RouteComponentProps } from 'react-router';
import { InjectedFormProps, ITranslateProps } from 'models/common';
import { getShopCard } from 'redux/modules/shop/shopcard';
import { Button, LoadingOverlayWrapper } from 'components';
import { DiscountStrategyType, IDiscountStrategy } from 'models/shop/discountStrategies';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { BookingDatePicker, BookingInputField, BookingSelectMenu, BookingTextareaField } from 'components/FormControls';
import { reduxForm, Field, change } from 'redux-form';
import { aboveZero, isNumber, maxLength, maxValue, required, scrollErrorIntoView } from 'helpers/validationattributes';
import { detectIncompatibleBrowsers, getCurrencySymbol, setOtherZone } from 'helpers/common';
import renderIcon from 'helpers/renderIcon';
import { CustomerCheckboxField } from '../ShopBundlesServicesAddEdit/ShopServicesSingleAddEdit/CustomerCheckboxField';
import TreeSelector, { ITreeSelectorItem } from 'components/Common/TreeSelector';
import { getBookingTemplatesByOffice } from 'redux/modules/shop/bookingtemplates';
import { IServicesList } from 'models/shop/shopBookingTemplates';
import { getOfficeServiceGroups } from 'redux/modules/shop/serviceGroups';
import { groupBy, unGroupCopy } from '../Helpers';
import { IServiceGroup } from 'models/shop/serviceGroups';
import { formatMinServiceDuration, formatMinServicePrice } from 'helpers/bookingTemplates';
import { actions as notifActions } from 'redux-notifications';
import {
	addEditBatchDiscountStrategies,
	deleteDiscountStrategyGroup,
	getDiscountStrategies,
} from 'redux/modules/shop/discountStrategies';
import { setLocalZone } from 'components/FormControls/BookingDatePicker';
import { momentWithTimezone } from 'redux/modules/shop/helpers';
require('./style.scss');

const priceRequired = (val) => required(typeof val == 'number' && !isNaN(val) && isFinite(val) ? String(val) : val);
const maxValue100 = maxValue(100);
interface INewPromotionForm extends IDiscountStrategy {
	locations: { [key: string]: boolean };
	discountValue_isPercentage_1?: string;
	discountValue_isPercentage_0?: string;
	serviceOfficeSelector: string;
	selectedBookingTemplates?: { [key: string]: boolean };
	saleStarts?: string;
	saleEnds?: string;
}

interface IParams {
	shopId: string;
	promotionType?: DiscountStrategyType;
	/**
	 * this is provided in edit mode
	 */
	promotionGroupId?: string;
	mode?: 'edit' | 'duplicate' | 'new';
}

interface IOwnProps extends RouteComponentProps<IParams, {}> {}

interface IProps
	extends IOwnProps,
		InjectedFormProps<INewPromotionForm>,
		ITranslateProps,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps> {
	currentFormValues: INewPromotionForm;
}

const allLocations = (offices, value = true) => {
	if (!offices) return {};
	const out = {};
	offices.forEach((key) => (out[key?.id] = value));
	return out;
};

interface IState {
	selectedTab: string;
	searchServicesField: string;
	allBookingTemplateIdsByVariantParentId: { [key: string]: string[] };
	/**
	 * Remember bookingtemplates for variant parent ids,
	 * to prevent looping through allServices every time the variant is needed
	 * (not all data is available when edit/duplicate mode)
	 */
	allBookingTemplatesByBookingTemplateId: { [key: string]: IServicesList };
}

const maxLength250 = maxLength(250);

const mapStateToProps = (state: IStore, ownProps: IOwnProps) => {
	let currentFormValues: INewPromotionForm = null;
	if (state.form[c.FORM_NAME_NEW_PROMOTION] && state.form[c.FORM_NAME_NEW_PROMOTION].values) {
		currentFormValues = state.form[c.FORM_NAME_NEW_PROMOTION].values;
	}

	let initialValues: Partial<INewPromotionForm> = {
		isDiscountPercentage: true,
		locations: allLocations(state.shopcard.shopcard?.offices),
		type: ownProps.params?.promotionType,
	};

	if (
		ownProps.params?.promotionGroupId &&
		state.discountStrategyReducer?.groupedDiscountStrategies?.[ownProps.params.promotionGroupId]
	) {
		const existingGroup = state.discountStrategyReducer?.groupedDiscountStrategies?.[ownProps.params.promotionGroupId];
		const existingData = existingGroup[0];
		const selectedBookingTemplates = {};
		const selectedLocations = {};
		existingGroup.forEach((grp) => {
			selectedBookingTemplates[grp.bookingTemplateId] = true;
			selectedLocations[grp.officeId] = true;
		});

		const existingDataOffice = state.shopcard?.shopcard?.offices?.find((of) => of.id == existingData.officeId);
		const timezone = existingDataOffice?.zoneInfo;

		initialValues = {
			title:
				ownProps.params.mode == 'duplicate'
					? existingData.title + i18n.t('Shop_Promotions_Duplicate_TitleSuffix')
					: existingData.title,
			description: existingData.description,
			isDiscountPercentage: existingData.isDiscountPercentage,
			[`discountValue_isPercentage_${existingData.isDiscountPercentage ? 1 : 0}`]: existingData.discountValue,
			saleStarts: setLocalZone(existingData.validFrom, timezone).toUTCString(),
			saleEnds: setLocalZone(existingData.validTo, timezone).toUTCString(),
			locations: selectedLocations,
			selectedBookingTemplates,
			type: existingData.type,
			isActive: existingData.isActive,
		};
	}

	return {
		shopBookingTemplates: state.shopBookingTemplates,
		serviceGroups: state.serviceGroups,
		shopCard: state.shopcard.shopcard,
		entireShopCard: state.shopcard,
		discountStrategies: state.discountStrategyReducer,
		currentFormValues,
		initialValues,
	};
};

interface ITreeSelectorData {
	id: string;
	name: string;
	duration: string;
	price: string;
	description?: string;
}

const mapDispatchToProps = (dispatch: Dispatch<IStore>, ownProps: IOwnProps) => ({
	getShopCard: () => dispatch(getShopCard(ownProps.params.shopId, false, true)),
	change: (field: string, value: any) => {
		dispatch(change(field, value));
	},
	getBookingTemplates: (officeId) => {
		dispatch(getOfficeServiceGroups(officeId));
		dispatch(getBookingTemplatesByOffice(officeId, false));
	},
	addEditBatchDiscountStrategies: (
		basicDiscountStrategyData: IDiscountStrategy,
		discountStrategySpecificData: Pick<IDiscountStrategy, 'bookingTemplateId' | 'officeId' | 'validFrom' | 'validTo'>[],
	) =>
		dispatch((dispatch, getState) =>
			addEditBatchDiscountStrategies(
				dispatch,
				getState,
				ownProps.params.shopId,
				unGroupCopy(
					{
						...basicDiscountStrategyData,
						isActive: ownProps.params.mode == 'edit' ? basicDiscountStrategyData.isActive : true,
					},
					['bookingTemplateId', 'officeId', 'validFrom', 'validTo'],
					discountStrategySpecificData,
				),
				ownProps.params.mode == 'edit' ? ownProps.params.promotionGroupId : undefined,
			),
		),
	deleteDiscountStrategyGroup: (groupId) =>
		dispatch((dispatch, getState) => deleteDiscountStrategyGroup(dispatch, getState, ownProps.params.shopId, groupId)),
	showNotification: (message: string, kind: string, dismissAfter = 3000) =>
		dispatch(notifActions.notifSend({ message, kind, dismissAfter })),
	getDiscountStrategies: (shopId) => dispatch(getDiscountStrategies(shopId)),
});
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class NewPromotionForm extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			selectedTab: 'details',
			searchServicesField: '',
			allBookingTemplateIdsByVariantParentId: {},
			allBookingTemplatesByBookingTemplateId: {},
		};

		this.renderLocationSelector = this.renderLocationSelector.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.loadDataIntoState = this.loadDataIntoState.bind(this);
	}

	public componentDidMount(): void {
		if (
			(!this.props.shopCard && !this.props.entireShopCard.isFetching) ||
			this.props.shopCard?.id != this.props.params.shopId ||
			!this.props.shopCard?.offices
		) {
			this.props.getShopCard();
		}

		// fetch only if in edit mode
		if (
			this.props.params?.promotionGroupId &&
			!this.props.discountStrategies.groupedDiscountStrategies &&
			!this.props.discountStrategies.error &&
			!this.props.discountStrategies.isFetching
		) {
			this.props.getDiscountStrategies(this.props.params.shopId);
		}

		this.loadDataIntoState();
	}

	public componentDidUpdate(prevProps: Readonly<IProps>): void {
		// autofill location selector on services tab
		if (
			this.props.currentFormValues &&
			this.props.currentFormValues?.locations && // if values and locations are loaded
			// if service office selector is empty
			(!this.props.currentFormValues?.serviceOfficeSelector ||
				// or an office is selected that is filtered out
				!this.props.currentFormValues?.locations?.[this.props.currentFormValues?.serviceOfficeSelector])
		) {
			const firstSelectedLocations = this.props.shopCard?.offices?.find(
				(office) => this.props.currentFormValues?.locations?.[office?.id],
			);
			this.props.change('serviceOfficeSelector', firstSelectedLocations?.id);
		}

		if (
			this.props.currentFormValues?.serviceOfficeSelector &&
			prevProps.currentFormValues?.serviceOfficeSelector != this.props.currentFormValues?.serviceOfficeSelector
		) {
			this.props.getBookingTemplates(this.props.currentFormValues?.serviceOfficeSelector);
		}

		if (
			this.props.shopBookingTemplates.services?.length != prevProps.shopBookingTemplates.services?.length ||
			this.props.shopBookingTemplates.services?.[0]?.officeId != prevProps.shopBookingTemplates.services?.[0]?.officeId
		) {
			this.loadDataIntoState();
		}
	}

	private loadDataIntoState() {
		const bookingTemplateIdsByVp = {};
		const btByBtid = {};
		const selectedVpId = new Set();
		const selectedBookingTemplates = {
			...(this.props.initialValues?.selectedBookingTemplates || {}),
			...(this.props.currentFormValues?.selectedBookingTemplates || {}),
		};
		this.props.shopBookingTemplates.services?.forEach((bt) => {
			// group varient parent ids by booking template ids
			btByBtid[bt.id] = bt;

			// When data is loaded into the form, all variants are selected.
			// If office booking templates were not fetched yet, this is fine
			// because when saving we need the discount to apply to all variations.
			// When booking templates have been loaded, deselect all booking templates
			// with the same variation except one. (the whole variation is selected on submit)
			if (selectedBookingTemplates[bt.id]) {
				if (selectedVpId.has(bt.variantParentId)) {
					delete selectedBookingTemplates[bt.id];
				} else {
					selectedVpId.add(bt.variantParentId);
				}
			}

			// group by variantParentId
			(bookingTemplateIdsByVp[bt.variantParentId] = bookingTemplateIdsByVp[bt.variantParentId] || []).push(bt.id);
		});

		this.props.change('selectedBookingTemplates', selectedBookingTemplates);

		this.setState((state) => ({
			allBookingTemplateIdsByVariantParentId: {
				...state.allBookingTemplateIdsByVariantParentId,
				...bookingTemplateIdsByVp,
			},
			allBookingTemplatesByBookingTemplateId: { ...state.allBookingTemplatesByBookingTemplateId, ...btByBtid },
		}));
	}

	private renderLocationSelector = () => {
		const { t } = this.props;
		const formValues = this.props.currentFormValues;

		const offices = this.props.shopCard?.offices;

		if (!offices) {
			return;
		}

		let countSelected = 0;
		let allSelected = false;

		(Object.keys(formValues?.locations || {}) || []).map((mba) => {
			if (formValues?.locations[mba] === true) {
				countSelected = countSelected + 1;
			}
		});

		if (countSelected === offices?.length) {
			allSelected = true;
		} else {
			allSelected = false;
		}

		let selectAllElement: JSX.Element = null;

		if (countSelected === 0) {
			selectAllElement = renderIcon('unchecked', 24, 24);
		} else if (allSelected === true) {
			selectAllElement = renderIcon('checked', 24, 24);
		} else {
			selectAllElement = renderIcon('partially_checked', 24, 24);
		}

		return (
			<div className="row locationSelector">
				<div className="col-12">
					<div
						className="selectAll"
						onClick={() => this.props.change('locations', allLocations(offices, !allSelected))}
					>
						{selectAllElement}
						<span className="selectAllText">{t('BSPortal_Common_SelectAll')}</span>
						<span className="selectAllGrayText">({offices.length})</span>
					</div>
				</div>
				{offices.map((office, idx) => {
					return (
						<div className="col-md-6 col-12" key={office.id + idx}>
							<Field
								name={`locations.[${office.id}]`}
								component={CustomerCheckboxField}
								type="checkbox"
								label={office.location}
								jobTitle={office.name}
								dontShowCustomer={true}
							/>
						</div>
					);
				})}
			</div>
		);
	};

	private discountTypes = [
		{ order: 0, key: true, value: this.props.t('Shop_Promotions_New_DiscountValue_DiscountType_0') },
		{ order: 1, key: false, value: this.props.t('Shop_Promotions_New_DiscountValue_DiscountType_1') },
	];

	private onSubmit(form: INewPromotionForm) {
		if (this.state.selectedTab != 'services') {
			this.setState({ selectedTab: 'services' });

			if (detectIncompatibleBrowsers()) {
				document.body.scrollTo(0, 0);
			} else {
				window.scrollTo(0, 0);
			}

			return;
		}

		const existingDiscountStratByBt: { [key: string]: IDiscountStrategy } = {};
		this.props.discountStrategies?.groupedDiscountStrategies?.[this.props.params.promotionGroupId]?.forEach(
			(dicountStrat) => {
				existingDiscountStratByBt[dicountStrat.bookingTemplateId] = dicountStrat;
			},
		);

		const officesById = groupBy(this.props.shopCard.offices, 'id');

		const discountStrategyInfo: IDiscountStrategy = {
			shopId: this.props.shopCard.id,
			title: form.title,
			description: form.description,
			validFrom: form.saleStarts,
			validTo: form.saleEnds,
			isDiscountPercentage: !!form.isDiscountPercentage,
			discountValue: parseInt(
				form.isDiscountPercentage ? form.discountValue_isPercentage_1 : form.discountValue_isPercentage_0,
			),
			type: parseInt(form.type as any),
			isActive: form.isActive,
		};

		const bookingTemplateDiscountStrategies: Partial<IDiscountStrategy>[] = [];

		// loop through selected, to find edited and created elements
		Object.keys(form.selectedBookingTemplates).forEach((btId) => {
			if (form.selectedBookingTemplates?.[btId]) {
				const bookingTemplate = this.state.allBookingTemplatesByBookingTemplateId?.[btId];

				// if a booking template is selected but the office booking templates are not loaded
				// add just the booking template because we do not know which other booking templates
				// belong to the same variantParentId
				// this should be handled when editing the target service
				if (bookingTemplate) {
					if (form.locations?.[bookingTemplate?.officeId]) {
						const variations = this.state.allBookingTemplateIdsByVariantParentId?.[bookingTemplate?.variantParentId];
						const timezone = officesById?.[bookingTemplate?.officeId]?.[0]?.zoneInfo;
						variations.forEach((variationBtId) => {
							const variationBt = this.state.allBookingTemplatesByBookingTemplateId?.[variationBtId];
							bookingTemplateDiscountStrategies.push({
								bookingTemplateId: variationBt.id,
								officeId: variationBt.officeId,
								// if discount starts at 8:00 that means 8:00 in the office timezone
								validFrom: setOtherZone(discountStrategyInfo.validFrom, timezone),
								validTo: setOtherZone(discountStrategyInfo.validTo, timezone),
							});
						});
					}
				} else {
					const existingDiscount = existingDiscountStratByBt[btId];
					if (form.locations[existingDiscount?.officeId]) {
						const timezone = officesById?.[existingDiscount?.officeId]?.[0]?.zoneInfo;
						bookingTemplateDiscountStrategies.push({
							bookingTemplateId: existingDiscount.bookingTemplateId,
							officeId: existingDiscount?.officeId,
							validFrom: setOtherZone(discountStrategyInfo.validFrom, timezone),
							validTo: setOtherZone(discountStrategyInfo.validTo, timezone),
						});
					}
				}
			}
		});

		let res: Promise<any> = null;
		if (bookingTemplateDiscountStrategies?.length) {
			res = this.props.addEditBatchDiscountStrategies(discountStrategyInfo, bookingTemplateDiscountStrategies);
		}

		(res || Promise.reject())
			.then(() => {
				this.props.showNotification(this.props.t('Shop_Promotions_SavedSuccessfully'), 'success');
				browserHistory.push(`/shop/${this.props.params.shopId}/edit/promo`);
			})
			.catch((e) => {
				this.props.showNotification(e, 'error');
			});

		return res;
	}

	get treeSelectorItems(): ITreeSelectorItem<ITreeSelectorData>[] {
		if (
			!this.props.serviceGroups?.serviceGroups ||
			!this.props.serviceGroups?.serviceGroups ||
			this.props.serviceGroups?.serviceGroups?.[0]?.officeId != this.props.shopBookingTemplates?.services?.[0]?.officeId
		)
			return [];

		const serviceGroupsById: { [key: string]: IServiceGroup[] } = groupBy(
			this.props.serviceGroups.serviceGroups || [],
			'id',
		);
		const servicesByServiceGroupId: { [key: string]: IServicesList[] } = groupBy(
			this.props.shopBookingTemplates.services || [],
			'serviceGroupId',
		);
		const servicesByVariantParentId: { [key: string]: IServicesList[] } = groupBy(
			this.props.shopBookingTemplates.services || [],
			'variantParentId',
		);

		let hasErroredItems = false;

		const out = Object.keys(servicesByVariantParentId).map((vpId) => {
			const bt = servicesByVariantParentId[vpId][0];
			const sg = serviceGroupsById?.[bt.serviceGroupId]?.[0];

			if (!sg) {
				hasErroredItems = true;
				return;
			}

			const isSubservice =
				servicesByServiceGroupId[bt.serviceGroupId].findIndex(
					(btInSameService) => btInSameService.variantParentId != bt.variantParentId,
				) != -1;
			const price = formatMinServicePrice(
				servicesByVariantParentId[vpId],
				this.props.t,
				this.props.shopCard?.currencyKey,
			);
			const duration = formatMinServiceDuration(servicesByVariantParentId[vpId], this.props.t);
			const customData: { isBundle: boolean; bundleChildrenNames: string[] } = JSON.parse(bt.customData || '{}');

			return {
				categoryKey: bt.categoryKey,
				categoryName: this.props.t(`DV_ServiceCategories_${bt.categoryKey}`),
				dropdownCategoryKey: sg.parentId,
				dropdownCategoryName: serviceGroupsById[sg.parentId]?.[0]?.value,
				data: {
					id: bt.id,
					name: isSubservice ? `${sg.value} / ${bt.name}` : bt.name,
					price,
					duration,
					description: customData.isBundle ? customData.bundleChildrenNames.join(', ') : undefined,
				},
			};
		});

		if (hasErroredItems) return out.filter((x) => x);

		return out;
	}

	render() {
		const { shopCard, t, handleSubmit, currentFormValues, initialValues } = this.props;
		const promotionType = initialValues.type;

		const selectedLocations = shopCard?.offices?.filter((office) => currentFormValues?.locations?.[office?.id]);
		let submitDisabled =
			Object.keys(currentFormValues?.selectedBookingTemplates || {}).reduce(
				(prev, curr) => prev + (currentFormValues.selectedBookingTemplates?.[curr] ? 1 : 0),
				0,
			) == 0;
		submitDisabled = submitDisabled || this.props.submitting;

		// have to do it like this because react tabs can't render the Button component outside of TabContent
		const bottomContentWrapper = (buttons) => (
			<div className="bottomContainer">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-lg-6 col-12">{buttons}</div>
					</div>
				</div>
			</div>
		);

		const editMode = this.props.params.promotionGroupId;

		return (
			<Tabs
				renderActiveTabContentOnly={true}
				handleSelect={(selectedTab) => {
					this.setState({ selectedTab });
				}}
				name="newPromotionTabs"
				tabComponent="div"
				selectedTab={this.state.selectedTab}
				className="newPromotionContainer container topPadding position-relative"
			>
				<aside className="sideNav d-none d-lg-block">
					<TabLink key="details" className="tabLink" to={'details'}>
						{t('Shop_Promotions_New_TabDetails')}
					</TabLink>
					{!this.props.invalid && (
						<TabLink key="services" className="tabLink" to={'services'}>
							{t('Shop_Promotions_New_TabServices')}
						</TabLink>
					)}
					{this.props.invalid && <div className="tabLink disabled">{t('Shop_Promotions_New_TabServices')}</div>}
				</aside>
				<form className="promotions row d-flex flex-row justify-content-center" onSubmit={handleSubmit(this.onSubmit)}>
					<LoadingOverlayWrapper
						className="subsection-main col-lg-6 col-12"
						active={
							this.props.entireShopCard?.isFetching ||
							this.props.shopBookingTemplates.isFetching ||
							this.props.submitting
						}
					>
						<TabContent key="details" for={'details'}>
							<p className="mutedDescription">{t('Shop_Promotions_New_Description')}</p>
							<h1>{t(`Shop_Promotions_${editMode ? 'Edit' : 'New'}_Title_Type_${promotionType}`)}</h1>

							<h3 className="firstSubtitle">{t('Shop_Promotions_New_BasicInfo_Title')}</h3>
							<p className="mutedDescription">{t('Shop_Promotions_New_BasicInfo_Description')}</p>
							<div className="sectionContent">
								<Field
									name="title"
									component={BookingInputField}
									clasName="noMarginTop"
									placeholder={t('Shop_Promotions_New_BasicInfo_Name_Desc')}
									information={t(`Shop_Promotions_New_BasicInfo_Name_Type_${promotionType}`)}
									validate={[required]}
								/>
								<Field
									name="description"
									component={BookingTextareaField}
									placeholder={t('Shop_Promotions_New_BasicInfo_Description_Desc')}
									description={t('Shop_Promotions_New_BasicInfo_Description_Notice')}
									information={t(`Shop_Promotions_New_BasicInfo_Description_Type_${promotionType}`)}
									validate={[maxLength250]}
								/>
							</div>

							<h3>{t('Shop_Promotions_New_Duration_Title')}</h3>
							<p className="mutedDescription">{t('Shop_Promotions_New_BasicInfo_Description')}</p>
							<div className="sectionContent reducedMargin">
								<div className="row">
									<Field
										name="saleStarts"
										className="col-md-6 col-12"
										type="text"
										component={BookingDatePicker}
										label={t('Shop_WorkTime_StartDate')}
										information={t(`Shop_Promotions_New_Duration_Starts_Type_${promotionType}`)}
										maxDate={this.props.currentFormValues?.saleEnds && new Date(this.props.currentFormValues.saleEnds)}
										minDate={momentWithTimezone().startOf('day').toDate()}
										validate={[required]}
									/>
									<Field
										name="saleEnds"
										className="col-md-6 col-12"
										type="text"
										component={BookingDatePicker}
										label={t(`Shop_Promotions_New_Duration_Ends_Type_${promotionType}`)}
										information={t(`Shop_Promotions_New_Duration_Ends_Type_${promotionType}`)}
										minDate={
											(this.props.currentFormValues?.saleStarts && new Date(this.props.currentFormValues.saleStarts)) ||
											momentWithTimezone().startOf('day').toDate()
										}
										validate={[required]}
									/>
								</div>
								<div className="grayNotice">{t('Shop_Promotions_New_Duration_Notice')}</div>
							</div>

							<h3>{t('Shop_Promotions_New_DiscountValue_Title')}</h3>
							<p className="mutedDescription">{t('Shop_Promotions_New_DiscountValue_Description')}</p>
							<div className="sectionContent reducedMargin">
								<div className="row">
									<Field
										name={`isDiscountPercentage`}
										component={BookingSelectMenu}
										items={this.discountTypes}
										type="text"
										label={t('Shop_Promotions_New_DiscountValue_DiscountType_Label')}
										information={t('Shop_Promotions_New_DiscountValue_DiscountType_Label')}
										isRequired={true}
										className="noMarginTop col-md-6 col-12"
										searchable={false}
									/>
									{currentFormValues?.isDiscountPercentage ? (
										<Field
											name={`discountValue_isPercentage_1`}
											component={BookingInputField}
											type="text"
											label={t('Shop_Promotions_New_DiscountValue_Discount')}
											validate={[priceRequired, isNumber, maxValue100]}
											min={0}
											step={0.1}
											inputMode={'decimal'}
											normalize={aboveZero}
											information={`${t('Shop_Promotions_New_DiscountValue_Discount')} (%)`}
											className="noMarginTop col-md-6 col-12"
										/>
									) : (
										<Field
											name={`discountValue_isPercentage_0`}
											component={BookingInputField}
											type="text"
											label={`${t('Shop_Promotions_New_DiscountValue_Discount')} (${getCurrencySymbol(
												this.props?.shopCard?.currencyKey,
											)})`}
											validate={[priceRequired, isNumber]}
											min={0}
											step={0.01}
											inputMode={'decimal'}
											normalize={aboveZero}
											information={`${t('Shop_Promotions_New_DiscountValue_Discount')} (${getCurrencySymbol(
												this.props?.shopCard?.currencyKey,
											)})`}
											className="noMarginTop col-md-6 col-12"
										/>
									)}
								</div>
							</div>

							{shopCard?.offices?.length > 1 && (
								<>
									<h3>{t('Shop_Promotions_New_Location_Title')}</h3>
									<p className="mutedDescription">{t('Shop_Promotions_New_Location_Description')}</p>
									<div className="sectionContent">{this.renderLocationSelector()}</div>
								</>
							)}
						</TabContent>
						<TabContent key="services" for={'services'}>
							<p className="mutedDescription">{t('Shop_Promotions_New_Description')}</p>
							<h1>{t(`Shop_Promotions_New_Title_Type_${promotionType}`)}</h1>

							<h3 className="firstSubtitle">{t('Shop_Promotions_New_Services_Title')}</h3>
							<p className="mutedDescription">{t('Shop_Promotions_New_Services_Description')}</p>
							<div className="sectionContent">
								<Field
									name={`serviceOfficeSelector`}
									component={BookingSelectMenu}
									items={selectedLocations?.map((office) => ({
										key: office.id,
										value: office.location,
										subLabel: office.name,
									}))}
									type="text"
									label={t('Shop_Promotions_New_Services_ShopLocation')}
									information={t('Shop_Promotions_New_Services_ShopLocation')}
									isRequired={true}
									twoPartLabels={true}
									searchable={false}
								/>

								<div className="inputHolder searchServices">
									{renderIcon('search1', 16, 16)}
									<input
										placeholder={t('Shop_Promotions_New_Services_SearchServices')}
										onChange={(event) => this.setState({ searchServicesField: event.target.value })}
										value={this.state.searchServicesField}
									/>
								</div>

								<TreeSelector<ITreeSelectorData>
									memoKey={this.props.shopBookingTemplates.services?.[0]?.officeId + this.state.searchServicesField}
									itemToFieldProps={(data) => ({
										name: `selectedBookingTemplates[${data.id}]`,
									})}
									getItemCurrentValue={(data) => this.props.currentFormValues?.selectedBookingTemplates?.[data.id]}
									renderItemLabel={(data) => (
										<div className="serviceSelectorRow">
											<div className="name">{data.name}</div>
											{data.description && <div className="description">{data.description}</div>}
											<div className="bottomRow">
												<span className="duration">{data.duration}</span>
												<span className="price">{data.price}</span>
											</div>
										</div>
									)}
									filterItems={
										this.state.searchServicesField &&
										((item) => item.data.name.toLowerCase().includes(this.state.searchServicesField.toLowerCase()))
									}
									items={this.treeSelectorItems}
									change={this.props.change}
									noFilterItemsErrorComponent={
										<div className="noResultsNote">
											<h2>{t('Shop_Promotions_SearchNoServices_Title')}</h2>
											<p>
												{this.state.searchServicesField &&
													t('Shop_Promotions_SearchNoServices_Desc', { search: this.state.searchServicesField })}
											</p>
										</div>
									}
								/>
							</div>
						</TabContent>
					</LoadingOverlayWrapper>
					{bottomContentWrapper(
						<>
							<TabContent key="details" for={'details'} className="buttonsContainer">
								<Link to={`/shop/${this.props.params.shopId}/edit/promo`} className="backButton">
									{renderIcon('leftRoundNoborder')} {t('BSPortal_Common_Back')}
								</Link>
								<Button
									type="submit"
									disabled={
										Object.keys(this.props.currentFormValues?.locations || {}).findIndex(
											(loc) => this.props.currentFormValues?.locations[loc],
										) == -1
									}
								>
									{t('BSPortal_Common_Next')}
								</Button>
							</TabContent>
							<TabContent key="services" for={'services'} className="buttonsContainer">
								<Button
									onClick={() => {
										this.setState({ selectedTab: 'details' });
										detectIncompatibleBrowsers() ? document.body.scrollTo(0, 0) : window.scrollTo(0, 0);
									}}
									className="backButton"
								>
									{renderIcon('leftRoundNoborder')} {t('BSPortal_Common_Back')}
								</Button>
								<Button type="submit" disabled={submitDisabled}>
									{editMode ? t('BSPortal_Common_Save') : t('BSPortal_Common_Create')}
								</Button>
							</TabContent>
						</>,
					)}
				</form>
			</Tabs>
		);
	}
}

let NewPromotion = reduxForm(
	{
		form: c.FORM_NAME_NEW_PROMOTION,
		enableReinitialize: true,
		onSubmitFail: () => scrollErrorIntoView(),
	},
	mapStateToProps,
)(NewPromotionForm);

NewPromotion = connect(mapStateToProps, mapDispatchToProps)(NewPromotion);

export { NewPromotion };
